/**
 * Every user-facing string for the Quick Allocation feature, in one place. The domain object is
 * a FUND GROUP in code and API; the UI copy follows the product mocks ("Allocation Group").
 * Renaming the UI is a change to this file only.
 */
export const FUND_GROUP_COPY = {
  quickAllocation: 'Quick Allocation',
  selectGroup: 'SELECT AN ALLOCATION GROUP',
  manage: 'Manage Quick Allocations',
  tooltipTitle: 'Lenders in this group',
  noGroupsYet: 'No allocation groups yet',
  noGroupsHint: 'Create one to allocate to the same entities in one click.',
  searchGroups: 'Search allocation groups...',
  createNew: 'Create New Allocation Group',
  editTitle: 'Edit Allocation Group',
  count: (n: number) => `${n} allocation group${n === 1 ? '' : 's'}`,
  noResults: (query: string) => `No allocation groups match "${query}"`,
  entityCount: (n: number) => `${n} ${n === 1 ? 'entity' : 'entities'}`,
  created: (date: string) => `Created: ${date}`,
  deleteConfirm: (name: string) => `Are you sure you want to delete '${name}'?`,
  delete: 'Delete',
  cancel: 'Cancel',
  save: 'Save Allocation Group',
  nameLabel: 'Allocation Group Name',
  nameRequired: 'Allocation group name is required',
  nameDuplicate: 'An allocation group with this name already exists',
  visibilityLabel: 'Visibility',
  privateLabel: 'Private',
  publicLabel: 'Public',
  privateHelp: 'Only you can see and use this quick allocation.',
  publicHelp: 'Everyone can see, use, edit and delete this quick allocation.',
  entitiesLabel: 'Select Entities',
  entitiesRequired: 'Select at least one entity',
  searchEntities: 'Search entities...',
  noEntitiesForManager: 'No entities are managed by this fund manager.',
  selected: (n: number) => `Selected: ${n} ${n === 1 ? 'entity' : 'entities'}`,
  appliedNothing: 'All entities in this group are already allocated.',
  appliedTitle: 'Quick allocation applied',
  applied: (n: number, name: string) =>
    `${n} ${n === 1 ? 'entity' : 'entities'} from "${name}" added with 0 amounts. Enter amounts and click Save.`,
  savedTitle: 'Allocation group saved',
  deletedTitle: 'Allocation group deleted',
  failedTitle: 'Allocation group failed to save',
  deleteFailedTitle: 'Allocation group failed to delete',
  loadFailedTitle: 'Could not load allocation groups',
} as const

/** The apply dropdown gains a search field once the user has MORE than this many groups. */
export const DROPDOWN_SEARCH_THRESHOLD = 5
